import keyMirror from '../../../utils/keyMirror';
import { comscoreBeacon } from '../../../../client/utils/comscoreUtils';

export const ONETRUST_SOURCE = 'onetrust';

// https://github.com/InteractiveAdvertisingBureau/GDPR-Transparency-and-Consent-Framework/blob/master/TCFv2/IAB%20Tech%20Lab%20-%20CMP%20API%20v2.md#cmp-api-v20
export const CMP_API_VERSION = 2;

// https://github.com/InteractiveAdvertisingBureau/GDPR-Transparency-and-Consent-Framework/blob/master/TCFv2/IAB%20Tech%20Lab%20-%20CMP%20API%20v2.md#what-required-api-commands-must-a-cmp-support
export const cmpApiCommands = keyMirror(
  'ping',
  'getTCData',
  'addEventListener',
  'removeEventListener',
);

// https://github.com/InteractiveAdvertisingBureau/GDPR-Transparency-and-Consent-Framework/blob/master/TCFv2/IAB%20Tech%20Lab%20-%20CMP%20API%20v2.md#addeventlistener
export const events = {
  tcLoaded: 'tcloaded',
  bannerShown: 'cmpuishown',
  consentUpdated: 'useractioncomplete',
};

// https://my.onetrust.com/s/article/UUID-d8291f61-aa31-813a-ef16-3f6dec73d643
export const oneTrustMethods = {
  closeAll: 'Close', // closes banner and settings dialog
  openSettingsDialog: 'ToggleInfoDisplay',
  setDataSubjectId: 'setDataSubjectId',
  getGeolocationData: 'getGeolocationData',
};

// https://app.onetrust.com/cookies/vendors/iabdetails/df62fe3e-b703-429f-a99e-0e156fc4d049
// https://app.onetrust.com/cookies/vendors/list
const vendorIds = { comscore: 77 };

// handlers should be defined with a single, opt-out-oriented Boolean parameter
export const vendorConsentHandlers = {
  [vendorIds.comscore]: comscoreBeacon,
};

// European Union Countries
export const gdprApplicableCountryCodes = keyMirror(
  'AT',
  'BE',
  'BG',
  'CY',
  'CZ',
  'DE',
  'DK',
  'EE',
  'EL',
  'ES',
  'FI',
  'FR',
  'HR',
  'HU',
  'IE',
  'IT',
  'LT',
  'LU',
  'LV',
  'MT',
  'NL',
  'PL',
  'PT',
  'RO',
  'SE',
  'SI',
  'SK',
);
